export default __webpack_public_path__ + "static/media/Sirocco's Lament.c6e23303.jpg";